import { ErrorService } from '@csp/web-common';
import { QueryCache, QueryClient, QueryClientConfig } from '@tanstack/react-query';

export const queryClientOptions: QueryClientConfig = {
  defaultOptions: {
    mutations: {
      networkMode: 'always',
    },
    queries: {
      networkMode: 'always',
    },
  },
  queryCache: new QueryCache({
    onError: (error): void => {
      ErrorService.handleError({ error });
    },
  }),
};

export const queryClient = new QueryClient(queryClientOptions);
